import classNames from 'classnames'
import React from 'react'
import { Location } from 'src/types/schema/graphql'
import HeroImage from './components/HeroImage'
import FiveImageLayout from './layouts/FiveImageLayout'
import FourImageLayout from './layouts/FourImageLayout'
import ThreeImageLayout from './layouts/ThreeImageLayout'
import TwoImageLayout from './layouts/TwoImageLayout'

interface ILocationGallery {
    location: Location
}

const LocationGallery: React.FC<ILocationGallery> = ({ location }) => {
    const heroAsset = location?.assets?.length > 0 && location?.assets?.[0]
    const singleImageLayout = location?.assets?.length === 1
    const imageCount = location?.assets?.length
    const wrapperClasses = classNames(
        'mx-auto grid w-full grid-cols-1 grid-rows-1 bg-white  py-4 px-4   sm:gap-3 xl:max-w-[1440px] xl:px-20',
        singleImageLayout ? 'sm:grid-cols-2' : 'sm:grid-cols-4 sm:grid-rows-2',
        imageCount === 2 && 'sm:grid-cols-2',
        imageCount === 3 && 'sm:grid-cols-4',
        imageCount === 4 && 'sm:grid-cols-4 sm:grid-rows-2'
    )
    const imageClasses = classNames(
        'h-full w-full',
        singleImageLayout ? 'max-h-[466px] object-cover' : 'h-full max-h-full w-full'
    )
    const renderLayout = () => {
        switch (imageCount) {
            case 1:
                return <HeroImage asset={heroAsset} imageClasses={imageClasses} />
            case 2:
                return <TwoImageLayout assets={location?.assets} imageClasses={imageClasses} />
            case 3:
                return <ThreeImageLayout assets={location?.assets} imageClasses={imageClasses} />
            case 4:
                return <FourImageLayout assets={location?.assets} imageClasses={imageClasses} />
            default:
                return <FiveImageLayout assets={location?.assets} imageClasses={imageClasses} />
        }
    }
    return <div className={wrapperClasses}>{renderLayout()}</div>
}
export default LocationGallery
